import { FORM_EFFECT_METADATA_KEY } from './metadata-keys';
import { DxFormEffect } from './interfaces';
import { addToMetadata } from '@digitaix/helpers';

export const DEFAULT_FORM_EFFECT_OPTIONS: Partial<DxFormEffect> = {
  dispatch: true,
  resubscribeOnError: true,
};

export function FormEffect(options: Partial<DxFormEffect> = {}) {
  return function(target: any, propertyKey: string) {
    addToMetadata(
      FORM_EFFECT_METADATA_KEY,
      {
        ...DEFAULT_FORM_EFFECT_OPTIONS,
        ...options,
        propertyKey
      },
      target
    );
  };
}
